module.exports = __webpack_public_path__ + "static/media/lupa.616b9444.svg";